module.exports = __webpack_public_path__ + "static/media/newhamster-0001.4dcd5d10.png";